import { render, staticRenderFns } from "./ShelvesManage.vue?vue&type=template&id=b47af76a&scoped=true"
import script from "./ShelvesManage.vue?vue&type=script&lang=js"
export * from "./ShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47af76a",
  null
  
)

export default component.exports